import React, { forwardRef } from 'react';
import { Box, BoxProps } from '@mui/material';
import { SwiperSlide, SwiperSlideProps, useSwiper } from 'swiper/react';

export interface CarouselSlideProps
  extends Omit<SwiperSlideProps, 'children'>, Omit<BoxProps, keyof SwiperSlideProps | 'component'> {
  children?: BoxProps['children'];
}

/**
 * One slide in the carousel
 */
export const CarouselSlide: React.FC<CarouselSlideProps> = forwardRef(({ children, sx, ...rest }, ref) => {
  const { params: swiperOptions } = useSwiper();

  return (
    <Box
      component={SwiperSlide}
      ref={ref}
      {...rest}
      sx={{
        display: 'block',
        width: swiperOptions?.slidesPerView === 'auto' ? 'auto' : '100%',
        height: swiperOptions?.autoHeight ? 'auto' : '100%',
        position: 'relative',
        zIndex: '50',
        transform: 'translate3d(0px, 0, 0)',
        flexShrink: '0',
        transitionProperty: swiperOptions?.effect === 'fade' ? 'opacity' : 'transform',
        '& img': {
          display: 'block',
          maxWidth: '100%',
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
});
CarouselSlide.displayName = 'SwiperSlide';
